import {ActionButton as $b41412308e87d8d9$export$cfc7921d29ef7b80} from "../button/ActionButton.mjs";
import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import {DialogContext as $45cab99fd43a8f38$export$8b93a07348a7730c} from "./context.mjs";
import {Grid as $572f9fec526c2697$export$ef2184bd89960b14} from "../layout/Grid.mjs";
import $gpOSB$intlStringsmjs from "./intlStrings.mjs";
import {SlotProvider as $62024859ff9f1f8a$export$8107b24b91795686, useSlotProps as $62024859ff9f1f8a$export$1e5c9e6e4e15efe3} from "../utils/Slots.mjs";
import "../dialog_vars.css";
import $gpOSB$dialog_vars_cssmjs from "../dialog_vars_css.mjs";
import {unwrapDOMRef as $3c2c983d5210446c$export$c7e28c72a4823176, useDOMRef as $3c2c983d5210446c$export$c2c55ef9111cafd8} from "../utils/useDOMRef.mjs";
import {useHasChild as $f57c7d8d50bdc255$export$e52e2242b6d0f1d4} from "../utils/useHasChild.mjs";
import {useStyleProps as $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41} from "../utils/styleProps.mjs";
import {useDialog as $gpOSB$useDialog} from "react-aria/useDialog";
import $gpOSB$spectrumiconsuiCrossLarge from "@spectrum-icons/ui/CrossLarge";
import {mergeProps as $gpOSB$mergeProps} from "react-aria/mergeProps";
import $gpOSB$react, {useContext as $gpOSB$useContext, useRef as $gpOSB$useRef, useMemo as $gpOSB$useMemo} from "react";
import {useLocalizedStringFormatter as $gpOSB$useLocalizedStringFormatter} from "react-aria/useLocalizedStringFormatter";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 














let $8054558191a4f1c9$var$sizeMap = {
    S: 'small',
    M: 'medium',
    L: 'large',
    fullscreen: 'fullscreen',
    fullscreenTakeover: 'fullscreenTakeover'
};
const $8054558191a4f1c9$export$3ddf2d174ce01153 = /*#__PURE__*/ (0, $gpOSB$react).forwardRef(function Dialog(props, ref) {
    props = (0, $62024859ff9f1f8a$export$1e5c9e6e4e15efe3)(props, 'dialog');
    let { type: type = 'modal', ...contextProps } = (0, $gpOSB$useContext)((0, $45cab99fd43a8f38$export$8b93a07348a7730c)) || {};
    let { children: children, isDismissable: isDismissable = contextProps.isDismissable, onDismiss: onDismiss = contextProps.onClose, size: size, ...otherProps } = props;
    let stringFormatter = (0, $gpOSB$useLocalizedStringFormatter)((0, ($parcel$interopDefault($gpOSB$intlStringsmjs))), '@react-spectrum/dialog');
    let { styleProps: styleProps } = (0, $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41)(otherProps);
    size = type === 'popover' ? size || 'S' : size || 'L';
    let domRef = (0, $3c2c983d5210446c$export$c2c55ef9111cafd8)(ref);
    let gridRef = (0, $gpOSB$useRef)(null);
    let sizeVariant = $8054558191a4f1c9$var$sizeMap[type] || $8054558191a4f1c9$var$sizeMap[size];
    let { dialogProps: dialogProps, titleProps: titleProps } = (0, $gpOSB$useDialog)((0, $gpOSB$mergeProps)(contextProps, props), domRef);
    let hasHeader = (0, $f57c7d8d50bdc255$export$e52e2242b6d0f1d4)(`.${(0, ($parcel$interopDefault($gpOSB$dialog_vars_cssmjs)))['spectrum-Dialog-header']}`, (0, $3c2c983d5210446c$export$c7e28c72a4823176)(gridRef));
    let hasHeading = (0, $f57c7d8d50bdc255$export$e52e2242b6d0f1d4)(`.${(0, ($parcel$interopDefault($gpOSB$dialog_vars_cssmjs)))['spectrum-Dialog-heading']}`, (0, $3c2c983d5210446c$export$c7e28c72a4823176)(gridRef));
    let hasFooter = (0, $f57c7d8d50bdc255$export$e52e2242b6d0f1d4)(`.${(0, ($parcel$interopDefault($gpOSB$dialog_vars_cssmjs)))['spectrum-Dialog-footer']}`, (0, $3c2c983d5210446c$export$c7e28c72a4823176)(gridRef));
    let hasTypeIcon = (0, $f57c7d8d50bdc255$export$e52e2242b6d0f1d4)(`.${(0, ($parcel$interopDefault($gpOSB$dialog_vars_cssmjs)))['spectrum-Dialog-typeIcon']}`, (0, $3c2c983d5210446c$export$c7e28c72a4823176)(gridRef));
    let slots = (0, $gpOSB$useMemo)(()=>({
            hero: {
                UNSAFE_className: (0, ($parcel$interopDefault($gpOSB$dialog_vars_cssmjs)))['spectrum-Dialog-hero']
            },
            heading: {
                UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($gpOSB$dialog_vars_cssmjs))), 'spectrum-Dialog-heading', {
                    'spectrum-Dialog-heading--noHeader': !hasHeader,
                    'spectrum-Dialog-heading--noTypeIcon': !hasTypeIcon
                }),
                level: 2,
                ...titleProps
            },
            header: {
                UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($gpOSB$dialog_vars_cssmjs))), 'spectrum-Dialog-header', {
                    'spectrum-Dialog-header--noHeading': !hasHeading,
                    'spectrum-Dialog-header--noTypeIcon': !hasTypeIcon
                })
            },
            typeIcon: {
                UNSAFE_className: (0, ($parcel$interopDefault($gpOSB$dialog_vars_cssmjs)))['spectrum-Dialog-typeIcon']
            },
            divider: {
                UNSAFE_className: (0, ($parcel$interopDefault($gpOSB$dialog_vars_cssmjs)))['spectrum-Dialog-divider'],
                size: 'M'
            },
            content: {
                UNSAFE_className: (0, ($parcel$interopDefault($gpOSB$dialog_vars_cssmjs)))['spectrum-Dialog-content']
            },
            footer: {
                UNSAFE_className: (0, ($parcel$interopDefault($gpOSB$dialog_vars_cssmjs)))['spectrum-Dialog-footer']
            },
            buttonGroup: {
                UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($gpOSB$dialog_vars_cssmjs))), 'spectrum-Dialog-buttonGroup', {
                    'spectrum-Dialog-buttonGroup--noFooter': !hasFooter
                }),
                align: 'end'
            }
        }), [
        hasFooter,
        hasHeader,
        titleProps
    ]);
    return /*#__PURE__*/ (0, $gpOSB$react).createElement("section", {
        ...styleProps,
        ...dialogProps,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($gpOSB$dialog_vars_cssmjs))), 'spectrum-Dialog', {
            [`spectrum-Dialog--${sizeVariant}`]: sizeVariant,
            'spectrum-Dialog--dismissable': isDismissable
        }, styleProps.className),
        ref: domRef
    }, /*#__PURE__*/ (0, $gpOSB$react).createElement((0, $572f9fec526c2697$export$ef2184bd89960b14), {
        ref: gridRef,
        UNSAFE_className: (0, ($parcel$interopDefault($gpOSB$dialog_vars_cssmjs)))['spectrum-Dialog-grid']
    }, /*#__PURE__*/ (0, $gpOSB$react).createElement((0, $62024859ff9f1f8a$export$8107b24b91795686), {
        slots: slots
    }, children), isDismissable && /*#__PURE__*/ (0, $gpOSB$react).createElement((0, $b41412308e87d8d9$export$cfc7921d29ef7b80), {
        UNSAFE_className: (0, ($parcel$interopDefault($gpOSB$dialog_vars_cssmjs)))['spectrum-Dialog-closeButton'],
        isQuiet: true,
        "aria-label": stringFormatter.format('dismiss'),
        onPress: onDismiss
    }, /*#__PURE__*/ (0, $gpOSB$react).createElement((0, $gpOSB$spectrumiconsuiCrossLarge), null))));
});


export {$8054558191a4f1c9$export$3ddf2d174ce01153 as Dialog};
//# sourceMappingURL=Dialog.mjs.map
